import NiotaClassicApiService from '@/services/niotaClassicApiService';
import listMixin from '@/components/niotaClassic/listMixin';
import { mapState } from 'vuex';
import { isCopyToClipboardSupported, copyToClipboard } from '@/utils/vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  page: 1,
  sortBy: ['id'],
  sortDesc: [false],
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicApplicationsLinkedDevicesList',
  mixins: [listMixin],
  props: {
    accountIds: {
      type: Array,
      required: false,
      default: undefined
    }
  },
  data: function () {
    return {
      lastSearch: '',
      deviceTypes: [],
      applications: [],
      tableOptions: defaultTableOptions,
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      deviceUpdateDialog: false,
      selectedRows: [],
      selected: [],
      deviceFormDialog: false,
      editAllFormDialog: false,
      createDeviceDialog: false,
      editedItem: {
        applicationId: this.$route.params.applicationId
      },
      deleteFromActility: false,
      isActility: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    actionButtons() {
      return [{
        icon: 'fal fa-plus',
        title: this.$i18n_t('NiotaClassic.Applications.createDevice'),
        action: 'createDevice',
        valid: this.isIotHubManager && !this.disabled && this.hasManagePermission,
        tooltip: this.$i18n_t('Common.addNew')
      }, {
        icon: 'fal fa-edit',
        title: this.$i18n_t('Common.edit'),
        action: 'showEditAllDialog',
        valid: this.isIotHubManager && this.selectedRows && this.selectedRows.length > 0
      }];
    },
    tableHeaders() {
      return [{
        text: this.$i18n_t('NiotaClassic.Common.table.id'),
        value: 'id',
        align: 'right'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.title'),
        value: 'title'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.table.eui'),
        value: 'eui'
      }, {
        text: this.$i18n_t('NiotaClassic.Applications.originator'),
        sortable: false,
        align: 'left',
        value: 'originator_title'
      },
      // {
      //   text: this.$i18n_t('NiotaClassic.Applications.table.threshold'),
      //   sortable: false,
      //   value: 'properties.minimum_packets_threshold',
      // },
      {
        text: this.$i18n_t('NiotaClassic.Applications.table.operationalStatus'),
        sortable: false,
        value: 'operationalStatus'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        value: 'createdAt'
      }, ...(this.isIotHubManager ? [{
        text: '',
        sortable: false,
        value: 'actions',
        width: 80
      }] : [])];
    }
  },
  watch: {
    accountIds: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }
      this.fetchList(true);
    }, 500)
  },
  mounted() {
    this.fetchList(true);
    this.deviceTypeFetchPlain();
    this.applicationsFetchPlain();
  },
  methods: {
    fetchList(fromStart) {
      if (this.isFetching) {
        return;
      }
      this.isFetching = true;
      const trimmedSearch = (this.searchItem || '').trim();
      if (this.lastSearch !== trimmedSearch || fromStart) {
        this.lastSearch = trimmedSearch;
        this.tableOptions = {
          ...this.tableOptions,
          page: 1
        };
      }
      const {
        sortBy,
        sortDesc,
        page,
        itemsPerPage
      } = this.tableOptions;
      const sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      const doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      const sortDirection = doSortDesc ? 'DESC' : 'ASC';
      const usedPage = Math.max(1, page || 1);
      const usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      let promise = undefined;
      if (trimmedSearch) {
        promise = NiotaClassicApiService.applicationDevicesFind(this.$route.params.applicationId, trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
      } else {
        promise = NiotaClassicApiService.applicationDevices(this.$route.params.applicationId, usedPage, usedItemsPerPage, sortItem, sortDirection);
      }
      promise.then(res => {
        this.list = res.data.devices;
        this.serverItemsLength = res.pagination.itemCount;
      }).catch(error => {
        console.error('Error fetching application devices', error);
      }).finally(() => {
        this.isFetching = false;
      });
    },
    refreshList() {
      this.fetchList(true);
      this.selected = [];
      this.selectedRows = [];
    },
    deletePromise() {
      return NiotaClassicApiService.applicationsDelete(this.selectedItem.id);
    },
    viewDevice(item) {
      this.$router.push({
        path: `/niota-classic/devices/${item.id}/details`
      });
    },
    rowSelectUpdate(rows) {
      this.selectedRows = rows;
    },
    getSelectedRows(rows) {
      this.selectedRows = rows;
    },
    editAll() {
      this.editAllFormDialog = true;
    },
    closeEditAllForm() {
      this.editAllFormDialog = false;
    },
    isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard(event, copyValue) {
      event.stopPropagation();
      copyToClipboard(copyValue);
    },
    openDeviceEditForm() {
      this.deviceEditItem = null;
      this.deviceEditDialog = true;
    },
    editItem() {
      this.openDeviceEditForm();
    },
    toggleEditDeviceDialog() {
      this.deviceFormDialog = !this.deviceFormDialog;
    },
    toggleEditAllDialog() {
      this.deviceUpdateDialog = !this.deviceUpdateDialog;
    },
    toggleCreateDeviceDialog() {
      this.createDeviceDialog = !this.createDeviceDialog;
    },
    deviceTypeFetchPlain() {
      NiotaClassicApiService.deviceTypeFetchPlain().then(res => {
        this.deviceTypes = res.data.devicetypes;
      }).catch(() => {
        this.deviceTypes = [];
        this.$snack(this.$i18n_t('NiotaClassic.Applications.form.errorFindingDeviceTypes'), 'error');
      });
    },
    applicationsFetchPlain() {
      NiotaClassicApiService.applicationsFetchPlain().then(res => {
        this.applications = res.data.applications;
      }).catch(() => {
        this.applications = [];
        this.$snack(this.$i18n_t('NiotaClassic.Applications.form.errorFindingApplications'), 'error');
      });
    },
    editDevice(device) {
      this.editedDevice = device;
      this.deviceFormDialog = true;
    },
    showDeletePrompt(item) {
      this.selectedItem = cloneDeep(item);
      this.isActility = (get(this.selectedItem, 'originator.type') || '').toLowerCase() === 'actility';
      this.deletePrompt = true;
    },
    /** closeDeletePrompt in listMixin */
    deleteFromRemote(remove) {
      this.deleteFromActility = remove;
    },
    deleteDevice() {
      let deletePromise = null;
      if (this.deleteFromActility) {
        deletePromise = NiotaClassicApiService.deviceDeleteFromActility(this.selectedItem.id);
      } else {
        deletePromise = NiotaClassicApiService.deviceDelete(this.selectedItem);
      }
      deletePromise.then(() => {
        this.selectedItem == null;
        this.$snack(this.$i18n_t('NiotaClassic.Applications.snacks.deviceDeleteSuccess'), 'success');
        this.refreshList();
      }).catch(() => {
        this.$snack(this.$i18n_t('NiotaClassic.Applications.snacks.deviceDeleteFailed'), 'error');
      }).finally(() => {
        this.deletePrompt = false;
      });
    },
    getOperationalStatus(device) {
      const allStatus = [this.$i18n_t('NiotaClassic.Devices.form.unset'), this.$i18n_t('NiotaClassic.Devices.form.inTransit'), this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'), this.$i18n_t('NiotaClassic.Devices.form.inOperation'), this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'), this.$i18n_t('NiotaClassic.Devices.form.decommissioned')];
      return allStatus[get(device, 'properties.operational_status.value')] || allStatus[3];
    }
  }
};